import { notificationManager } from '../Stores/NotificationManager'
import { restClient } from '@/Core'

interface ChangeNotificationIsReadedParams {
    uuid?: string
}

export const ChangeNotificationIsReadedTask = async ({
    uuid,
}: ChangeNotificationIsReadedParams = {}): Promise<void> => {
    if (!uuid) return

    try {
        await restClient.patch(`/services/user/notifications/${uuid}/change_is_readed`)

        notificationManager.markNotificationAsRead(uuid)
        notificationManager.decrementUnreadCount()
    } catch (error) {
        console.warn('ChangeNotificationIsReadedTask error:', error)
    }
}
